export default {
    full: "full",
    monthly: "monthly"
};
